import { GlobalServices } from '../../../services/global.service';
import { ssApiService } from '../../../services/ss-api.service';
import {
    GISPurchaseItemResponse,
    GISPurchaseItemResponseArray,
} from '../../../models/ss-api/responses/gis.purchase.item.response';
import { Component, OnInit } from '@angular/core';
import { HttpError } from 'app/models/errors/HttpError';

@Component({
    selector: 'account-gis-purchases-history',
    templateUrl: './gis-purchases-history.component.html',
    styleUrls: ['./gis-purchases-history.component.scss']
})
export class GisPurchasesHistoryComponent implements OnInit {

    // public
    GISPurchaseItems: GISPurchaseItemResponseArray = new GISPurchaseItemResponseArray();

    IsBusy: boolean = false;

    GISBundleResultRows: number = 25;
    BundleFirstResult: number = 0;
    BundleLastResult: number = 24;

    constructor(private api: ssApiService, private gb: GlobalServices) { }

    ngOnInit() {
        this.RefreshPurchaseHistory();
    }

    RefreshPurchaseHistory() {

        this.IsBusy = true;

        let request = this.api.GISPurchaseHistory()
            .subscribe(response => {
                request.unsubscribe();

                this.IsBusy = false;

                if (!response.Result)
                    return; // error

                this.GISPurchaseItems = response.Data;

            },


                (error: HttpError) => {
                    request.unsubscribe();
                    this.IsBusy = false;
                });


    }

    Remaining(item: GISPurchaseItemResponse): string {

        if (item.Remaining == 0)
            return '0';

        if (item.Refunded)
            return '0 - REFUNDED';

        if (item.Suspended)
            return '0 - SUSPENDED';

        if (item.Terminated)
            return '0 - EXPIRED -';

        if (item.ExpirationDate < new Date())
            return '0 - EXPIRED';


        return item.Remaining.toString();

    }

    paginateGISBundle(e) {
        this.BundleFirstResult = e.page * e.rows;
        this.BundleLastResult = this.BundleFirstResult + e.rows;
    }
}
